const initialLocaleAssign = {
  assignmentType: null,
  assignmentReferenceId: null,
  locale_Id: null,
};

export default initialLocaleAssign;
